import {useLayoutEffect, useRef} from "react";

export const useDimensionCallbackWithEvergreenNodeRef = (
  nodeRef: React.RefObject<HTMLElement | null>,
  cb: (dims: {width: number; height: number}) => void
) => {
  const cbRef = useRef(cb);
  cbRef.current = cb;
  useLayoutEffect(() => {
    const node = nodeRef.current!;
    let lastDims: null | {width: number; height: number} = null;
    const update = () => {
      const rect = node.getBoundingClientRect();
      if (!lastDims || rect.width !== lastDims.width || rect.height !== lastDims.height) {
        cbRef.current({width: rect.width, height: rect.height});
        lastDims = rect;
      }
    };
    const ro = new ResizeObserver(update);
    ro.observe(node);
    update();
    return () => {
      ro.disconnect();
    };
  }, [nodeRef]);
};
